const FONT = {
  FAMILY: "'Untitled Sans Regular', sans-serif !important;",
};

export default FONT;
